import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { db } from '../firebaseConfig';
import axios from 'axios';
import { useTheme } from '@mui/material/styles';
import { collection, addDoc, doc, setDoc, deleteDoc, getDocs, getDoc } from "firebase/firestore";
import './TradeEntryForm.css';
import MDButton from "components/MDButton";
import SentimentVerySatisfiedIcon from '@mui/icons-material/SentimentVerySatisfied';
import SentimentSatisfiedIcon from '@mui/icons-material/SentimentSatisfied';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from 'components/MDTypography';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import { Autocomplete, Container, IconButton, Paper, Grid, TextField, FormControlLabel, Chip, FormControl, InputLabel, Select, MenuItem, Checkbox } from '@mui/material';
import TextareaAutosize from '@mui/material/TextareaAutosize';

export function calculatePipIncrement(symbol) {
  const normalizedSymbol = symbol.toUpperCase() === 'DAX' ? 'GER40' : symbol.toUpperCase();
  const pipIncrement = {
    'AUDCAD': 0.0001, 'AUDCHF': 0.0001, 'AUDJPY': 0.01, 'AUDNZD': 0.0001, 'AUDUSD': 0.0001,
    'CADCHF': 0.0001, 'CADJPY': 0.01, 'CHFJPY': 0.01, 'EURAUD': 0.0001, 'EURCAD': 0.0001,
    'EURCHF': 0.0001, 'EURGBP': 0.0001, 'EURNZD': 0.0001, 'EURUSD': 0.0001, 'GBPAUD': 0.0001,
    'GBPCAD': 0.0001, 'GBPCHF': 0.0001, 'GBPJPY': 0.01, 'GBPNZD': 0.0001, 'GBPUSD': 0.0001,
    'NZDCAD': 0.0001, 'NZDCHF': 0.0001, 'NZDJPY': 0.01, 'NZDUSD': 0.0001, 'USDCAD': 0.0001,
    'USDCHF': 0.0001, 'USDJPY': 0.01, 'AUDGBP': 0.0001, 'AUDHKD': 0.0001, 'AUDSGD': 0.0001,
    'CHFHUF': 0.01, 'CHFPLN': 0.0001, 'EURAED': 0.0001, 'EURCZK': 0.0001, 'EURDKK': 0.0001,
    'EURHKD': 0.0001, 'EURHUF': 0.01, 'GBPCZK': 0.0001, 'GBPDKK': 0.0001, 'GBPTRY': 0.0001,
    'HKDJPY': 0.01, 'NZDSGD': 0.0001, 'SGDJPY': 0.01, 'USDCNH': 0.0001, 'USDHKD': 0.0001,
    'USDSGD': 0.0001, 'USDTRY': 0.0001, 'USDZAR': 0.0001, 'ZARJPY': 0.01, 'XAUUSD': 0.01,
    'XAGUSD': 0.01, 'XPTUSD': 0.01, 'XPDUSD': 0.01, 'WTIUSD': 0.01, 'BRENTUSD': 0.01,
    'COPPERUSD': 0.0001, 'NGASUSD': 0.01, 'COFFEEUSD': 0.01, 'SUGARUSD': 0.0001, 'COTTONUSD': 0.01,
    'US30': 1, 'SPX500': 1, 'NAS100': 1, 'UK100': 1, 'GER40': 1,
    'EURJPY': 0.01, 'EURPLN': 0.0001, 'EURTRY': 0.0001, 'GBPHKD': 0.0001, 'USDPLN': 0.0001,
    'USDMXN': 0.0001, 'AUDTRY': 0.0001, 'JPYHKD': 0.01, 'CHFSGD': 0.0001,   'ES_F': 0.25,
  'NQ_F': 0.25,
  'CL_F': 0.01,
  'GC_F': 0.1,
  'YM_F': 1,
  'RTY_F': 0.1,
  'ZB_F': 1/32,
  'ZN_F': 1/32,
  'ZF_F': 1/32,
  'HG_F': 0.01,
  'SI_F': 0.01,
  'PL_F': 0.1,
  'PA_F': 0.01,
  'RB_F': 0.0001,
  'HO_F': 0.0001,
  // Equities
  'AAPL': 0.01,
  'TSLA': 0.01,
  'MSFT': 0.01,
  'AMZN': 0.01,
  'GOOG': 0.01,
  'NVDA': 0.01,
  'META': 0.01,
  'SPY': 0.01,
  'QQQ': 0.01,
  'DIA': 0.01,
  'NFLX': 0.01,
  'INTC': 0.01,
  'AMD': 0.01,
  'BABA': 0.01,
  'IBM': 0.01,
  'ORCL': 0.01,
  'BA': 0.01,
  'GE': 0.01,
  'COST': 0.01,
  'PEP': 0.01,
  'KO': 0.01,
  'JNJ': 0.01,
  'PFE': 0.01,
  'MRK': 0.01,
  'V': 0.01,
  'MA': 0.01,
  'BAC': 0.01,
  'JPM': 0.01,
  'GS': 0.01,
  // Equity Index Micros
'MES_F': 0.25,
'MNQ_F': 0.25,
'MYM_F': 1,
'M2K_F': 0.10,

// Natural Gas
'NG_F': 0.001,

// Currency Futures
'6E_F': 0.00005,
'6J_F': 0.0000005,
'6B_F': 0.0001,
'6A_F': 0.0001,
'6C_F': 0.0001,
'6S_F': 0.0001,
  }[normalizedSymbol] || 0.0001;
  return pipIncrement;
}

export const detectAssetType = (symbol) => {
  if (!symbol) return 'forex';
  const upper = symbol.toUpperCase();

const futures = [
  // Equity Index Minis
  'ES_F', 'NQ_F', 'YM_F', 'RTY_F',

  // Equity Index Micros
  'MES_F', 'MNQ_F', 'MYM_F', 'M2K_F',

  // Energy / Metals
  'CL_F', 'NG_F',
  'GC_F', 'SI_F', 'HG_F', 'PL_F', 'PA_F',
  'RB_F', 'HO_F',

  // Rates
  'ZB_F', 'ZN_F', 'ZF_F',

  // Currency Futures
  '6E_F', '6J_F', '6B_F', '6A_F', '6C_F', '6S_F'
];

  // Equities
  const equities = [
    'AAPL', 'TSLA', 'MSFT', 'AMZN', 'GOOG', 'NVDA', 'META', 'SPY', 'QQQ', 'DIA', 'NFLX', 'INTC', 'AMD', 'BABA', 'IBM',
    'ORCL', 'BA', 'GE', 'COST', 'PEP', 'KO', 'JNJ', 'PFE', 'MRK', 'V', 'MA', 'BAC', 'JPM', 'GS'
  ];

  if (futures.includes(upper)) return 'futures';
  if (equities.includes(upper)) return 'equity';

  // Default to forex
  return 'forex';
};

const symbolOptions = [
  'AUDCAD', 'AUDCHF', 'AUDJPY', 'AUDNZD', 'AUDUSD', 'CADCHF', 'CADJPY', 'CHFJPY', 'EURAUD', 'EURCAD',
  'EURCHF', 'EURGBP', 'EURNZD', 'EURUSD', 'GBPAUD', 'GBPCAD', 'GBPCHF', 'GBPJPY', 'GBPNZD', 'GBPUSD',
  'NZDCAD', 'NZDCHF', 'NZDJPY', 'NZDUSD', 'USDCAD', 'USDCHF', 'USDJPY', 'AUDGBP', 'AUDHKD', 'AUDSGD',
  'CHFHUF', 'CHFPLN', 'EURAED', 'EURCZK', 'EURDKK', 'EURHKD', 'EURHUF', 'GBPCZK', 'GBPDKK', 'GBPTRY',
  'HKDJPY', 'NZDSGD', 'SGDJPY', 'USDCNH', 'USDHKD', 'USDSGD', 'USDTRY', 'USDZAR', 'ZARJPY', 'XAUUSD',
  'XAGUSD', 'XPTUSD', 'XPDUSD', 'WTIUSD', 'BRENTUSD', 'COPPERUSD', 'NGASUSD', 'COFFEEUSD', 'SUGARUSD',
  'COTTONUSD', 'US30', 'SPX500', 'NAS100', 'UK100', 'GER40', 'DAX',
    // New Additions
  'EURJPY', 'EURPLN', 'EURTRY', 'GBPHKD', 'USDPLN', 'USDMXN', 'AUDTRY', 'JPYHKD', 'CHFSGD',
// Futures
'ES_F','NQ_F','YM_F','RTY_F',
'MES_F','MNQ_F','MYM_F','M2K_F',
'CL_F','NG_F',
'GC_F','SI_F','HG_F','PL_F','PA_F',
'RB_F','HO_F',
'ZB_F','ZN_F','ZF_F',
'6E_F','6J_F','6B_F','6A_F','6C_F','6S_F',
  // Minis
'ES_F', 'NQ_F', 'YM_F', 'RTY_F',

// Micros
'MES_F', 'MNQ_F', 'MYM_F', 'M2K_F',
  // Equities
  'AAPL','TSLA','MSFT','AMZN','GOOG','NVDA','META','SPY','QQQ','DIA','NFLX','INTC','AMD','BABA','IBM',
  'ORCL','BA','GE','COST','PEP','KO','JNJ','PFE','MRK','V','MA','BAC','JPM','GS'
];

const exchangeRateSymbols = {
  'GBPJPY': 'USDJPY', 'EURGBP': 'GBPUSD', 'AUDJPY': 'USDJPY', 'AUDUSD': 'USDJPY', 'AUDCAD': 'USDCAD',
  'AUDCHF': 'USDCHF', 'AUDNZD': 'NZDUSD', 'CADJPY': 'USDJPY', 'CADCHF': 'USDCHF', 'CHFJPY': 'USDJPY',
  'EURAUD': 'AUDUSD', 'EURCAD': 'USDCAD', 'EURCHF': 'USDCHF', 'EURNZD': 'NZDUSD', 'EURUSD': 'EURUSD',
  'GBPAUD': 'AUDUSD', 'GBPCAD': 'USDCAD', 'GBPCHF': 'USDCHF', 'GBPNZD': 'NZDUSD', 'GBPUSD': 'GBPUSD',
  'NZDJPY': 'USDJPY', 'NZDUSD': 'NZDUSD', 'NZDCAD': 'USDCAD', 'NZDCHF': 'USDCHF', 'USDCAD': 'USDCAD',
  'USDCHF': 'USDCHF', 'USDJPY': 'USDJPY', 'AUDGBP': 'GBPUSD', 'AUDHKD': 'HKDUSD', 'AUDSGD': 'SGDUSD',
  'CHFHUF': 'USDHUF', 'CHFPLN': 'PLNUSD', 'EURAED': 'AEDUSD', 'EURCZK': 'CZKUSD', 'EURDKK': 'DKKUSD',
  'EURHKD': 'HKDUSD', 'EURHUF': 'USDHUF', 'GBPCZK': 'CZKUSD', 'GBPDKK': 'DKKUSD', 'GBPTRY': 'TRYUSD',
  'HKDJPY': 'USDJPY', 'NZDSGD': 'SGDUSD', 'SGDJPY': 'USDJPY', 'USDCNH': 'CNYUSD', 'USDHKD': 'HKDUSD',
  'USDSGD': 'SGDUSD', 'USDTRY': 'TRYUSD', 'USDZAR': 'ZARUSD', 'ZARJPY': 'USDJPY', 'US30': 'USD',
  'SPX500': 'USD', 'NAS100': 'USD', 'UK100': 'GBPUSD', 'GER40': 'EURUSD', 'DAX': 'EURUSD',
  'EURJPY': 'USDJPY', 'EURPLN': 'PLNUSD', 'EURTRY': 'TRYUSD', 'GBPHKD': 'HKDUSD', 'USDPLN': 'PLNUSD',
  'USDMXN': 'MXNUSD', 'AUDTRY': 'TRYUSD', 'JPYHKD': 'HKDUSD', 'CHFSGD': 'SGDUSD'
};

// Contract sizes for commission calculation (expand as needed)
const contractSizes = {
  'XAUUSD': 100, 'XAGUSD': 5000, 'XPTUSD': 50, 'XPDUSD': 100, 'WTIUSD': 1000, 'BRENTUSD': 1000,
  'COPPERUSD': 25000, 'NGASUSD': 10000, 'COFFEEUSD': 37500, 'SUGARUSD': 112000, 'COTTONUSD': 50000,
  'US30': 5, 'SPX500': 50, 'NAS100': 20, 'UK100': 10, 'GER40': 25, 'DAX': 25,
  'EURJPY': 100000, 'EURPLN': 100000, 'EURTRY': 100000, 'GBPHKD': 100000, 'USDPLN': 100000,
  'USDMXN': 100000, 'AUDTRY': 100000, 'JPYHKD': 100000, 'CHFSGD': 100000, 
// Futures - Equity Index Minis
'ES_F': 50,
'NQ_F': 20,
'YM_F': 5,
'RTY_F': 50,

// Futures - Equity Index Micros
'MES_F': 5,
'MNQ_F': 2,
'MYM_F': 0.5,
'M2K_F': 5,

// Energy
'CL_F': 1000,
'NG_F': 10000,

// Metals
'GC_F': 100,
'SI_F': 5000,
'HG_F': 25,
'PL_F': 50,
'PA_F': 100,

// Rates
'ZB_F': 1000,
'ZN_F': 1000,
'ZF_F': 1000,

// Refined products
'RB_F': 42000,
'HO_F': 42000,

// Currency Futures
'6E_F': 125000,
'6J_F': 12500000,
'6B_F': 62500,
'6A_F': 100000,
'6C_F': 100000,
'6S_F': 125000,

  // Equities
  'AAPL': 1, 'TSLA': 1, 'MSFT': 1, 'AMZN': 1, 'GOOG': 1, 'NVDA': 1, 'META': 1,
  'SPY': 1, 'QQQ': 1, 'DIA': 1, 'NFLX': 1, 'INTC': 1, 'AMD': 1, 'BABA': 1, 'IBM': 1,
  'ORCL': 1, 'BA': 1, 'GE': 1, 'COST': 1, 'PEP': 1, 'KO': 1, 'JNJ': 1,
  'PFE': 1, 'MRK': 1, 'V': 1, 'MA': 1, 'BAC': 1, 'JPM': 1, 'GS': 1
};

// Helper to get contract size (defaults to 100,000 for forex)
const getContractSize = (symbol) => {
  const normalizedSymbol = symbol.toUpperCase() === 'DAX' ? 'GER40' : symbol.toUpperCase();
  return contractSizes[normalizedSymbol] || 100000;
};

const API_KEY = process.env.REACT_APP_API_KEY;
const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getBaseCurrency = (tradeData) => {
  const symbol = typeof tradeData === 'string' ? tradeData : tradeData.symbol;
  const normalizedSymbol = symbol.toUpperCase() === 'DAX' ? 'GER40' : symbol;
  return normalizedSymbol.slice(0, 3);
};

export const getQuoteCurrency = (tradeData) => {
  const symbol = typeof tradeData === 'string' ? tradeData : tradeData.symbol;
  const normalizedSymbol = symbol.toUpperCase() === 'DAX' ? 'GER40' : symbol;
  return normalizedSymbol.slice(-3);
};

export const getExchangeRateSymbol = (tradeData) => {
  const symbol = typeof tradeData === 'string' ? tradeData : tradeData.symbol;
  const normalizedSymbol = symbol.toUpperCase() === 'DAX' ? 'GER40' : symbol;
  const baseCurrency = getBaseCurrency(normalizedSymbol);
  return exchangeRateSymbols[normalizedSymbol] || `${baseCurrency}USD`;
};

export const getExchangeRate = (tradeData) => {
  const symbol = typeof tradeData === 'string' ? tradeData : tradeData.symbol;
  const normalizedSymbol = symbol.toUpperCase() === 'DAX' ? 'GER40' : symbol.toUpperCase();

  // Symbols directly quoted in USD — exchange rate should always be 1
  const usdQuoted = [
    'XAUUSD', 'XAGUSD', 'XPTUSD', 'XPDUSD',
    'WTIUSD', 'BRENTUSD', 'COPPERUSD',
    'NGASUSD', 'COFFEEUSD', 'SUGARUSD',
    'COTTONUSD', 'US30', 'SPX500',
    'NAS100', 'UK100', 'GER40', 'DAX',
// Futures
'ES_F','NQ_F','YM_F','RTY_F',
'MES_F','MNQ_F','MYM_F','M2K_F',
'CL_F','NG_F',
'GC_F','SI_F','HG_F','PL_F','PA_F',
'RB_F','HO_F',
'ZB_F','ZN_F','ZF_F',
'6E_F','6J_F','6B_F','6A_F','6C_F','6S_F',
  // Equities
  'AAPL', 'TSLA', 'MSFT', 'AMZN', 'GOOG', 'NVDA', 'META', 'SPY', 'QQQ', 'DIA', 'NFLX', 'INTC', 'AMD', 'BABA', 'IBM',
  'ORCL', 'BA', 'GE', 'COST', 'PEP', 'KO', 'JNJ', 'PFE', 'MRK', 'V', 'MA', 'BAC', 'JPM', 'GS'
  ];

  if (usdQuoted.includes(normalizedSymbol)) return 1;

  const quoteCurrency = normalizedSymbol.slice(-3);
  if (quoteCurrency === 'USD') return 1;

  const baseCurrency = normalizedSymbol.slice(0, 3);
  if (baseCurrency === 'USD') return parseFloat(tradeData.exit) || 1;

  // Fallback to manually entered or fetched rate
  return parseFloat(tradeData.exchangeRate) || 1;
};

const fetchExchangeRate = async (symbol) => {
  try {
    const formattedSymbol = `${symbol.slice(0, 3)}/${symbol.slice(3)}`; // e.g., "USD/CAD"
    const params = {
      apikey: API_KEY,
      symbol: formattedSymbol,
    };

    const response = await axios.get(`${BASE_URL}/quote`, { params });
    if (response.data.code && response.data.message) {
      console.error('API Error:', response.data.code, response.data.message);
      return null;
    }

    return response.data.high ? parseFloat(response.data.high) : null; // Use latest high
  } catch (error) {
    console.error('Error fetching exchange rate from TwelveData:', error);
    return null;
  }
};

const Modal = ({ isOpen, onClose, title, children }) => {
  const theme = useTheme();
  if (!isOpen) return null;
  return (
    <div className="modal-overlay" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
      <div className="modal" style={{ backgroundColor: theme.palette.background.default || '#bac7db', padding: '20px', borderRadius: '8px', maxWidth: '500px', width: '100%', maxHeight: '80vh', overflowY: 'auto' }}>
        <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <MDTypography variant="h4" component="h2" style={{ margin: 0, fontWeight: 'bold', textAlign: 'center', alignItems: 'center' }}>
            {title}
          </MDTypography>

        </div>
        <div className="modal-content" style={{ marginTop: '16px' }}>{children}</div>
      </div>
    </div>
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

const TradeEntryForm = ({ userID, onTradeSubmit, setIsFormOpen, defaultDate }) => {
  const [tradeData, setTradeData] = useState({
        date: defaultDate || new Date().toISOString().split('T')[0],
    entryTime: '',
    exitDate: '',
    exitTime: '',
    symbol: '',
    entry: '',
    exit: '',
    status: 'Open',
    sizeType: 'lot',
    lotSizeEntry: '',
    shortLong: 'Long',
    returns: '',
    returnPercentage: '',
    leverage: '',
    sl: '',
    tp: '',
    riskAmount: '',
    comments: '',
    baseCurrency: '',
    exchangeRate: '',
    tradeConfidence: 'Medium',
    tags: [],
    commissionType: 'off',
    commissionValue: '',
    tradeAccountID: 'default', // New field for trade account
    tradingViewUrls: {
      htf: '',
      ltf: '',
      extra: '',
    },
  });

  const [tradeAccounts, setTradeAccounts] = useState([{ id: 'default', name: 'Default' }]);
  const [showExchangeRateInput, setShowExchangeRateInput] = useState(false);
  const theme = useTheme();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [tags, setTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [tagInput, setTagInput] = useState('');
  const [commissionType, setCommissionType] = useState('off');
  const [commissionValue, setCommissionValue] = useState('');
  const [isChecklistModalOpen, setIsChecklistModalOpen] = useState(false);
  const [checklist, setChecklist] = useState(null);
  const [previewTimeframe, setPreviewTimeframe] = useState('htf');
  const [checklistResponses, setChecklistResponses] = useState([]);
  const [isLowScoreConfirmOpen, setIsLowScoreConfirmOpen] = useState(false);
  const iconColor = theme.palette.mode === 'dark' ? theme.palette.grey[200] : theme.palette.grey[600];
  

  // Fetch trade accounts with names
  useEffect(() => {
    const fetchTradeAccounts = async () => {
      try {
        const tradeAccountsRef = collection(db, "Users", userID, "tradeAccounts");
        const tradeAccountsSnapshot = await getDocs(tradeAccountsRef);
        const accounts = tradeAccountsSnapshot.docs.map(doc => ({
          id: doc.id,
          name: doc.data().name || doc.id, // Fallback to ID if no name
        }));
        // Ensure 'default' is included and first
        const defaultAccount = accounts.find(acc => acc.id === 'default') || { id: 'default', name: 'Default' };
        const otherAccounts = accounts.filter(acc => acc.id !== 'default');
        setTradeAccounts([defaultAccount, ...otherAccounts]);
      } catch (error) {
        console.error('Error fetching trade accounts:', error);
        setTradeAccounts([{ id: 'default', name: 'Default' }]); // Fallback
      }
    };
    fetchTradeAccounts();
  }, [userID]);

  useEffect(() => {
    const fetchTags = async () => {
      const tagCollectionRef = collection(db, "Users", userID, "tags");
      const tagSnapshot = await getDocs(tagCollectionRef);
      const fetchedTags = tagSnapshot.docs.map(doc => doc.id);
      setTags(fetchedTags);
    };
    fetchTags();
  }, [userID]);

  useEffect(() => {
    const fetchChecklist = async () => {
      const userDoc = await getDoc(doc(db, 'Users', userID));
      
      // Explicitly check if checklistEnabled is true (not truthy but exactly true)
      if (userDoc.exists() && userDoc.data().checklistEnabled === true) {
        const checklistDoc = await getDoc(doc(db, 'Users', userID, 'checklists', 'primary'));
        if (checklistDoc.exists()) {
          // Only set the checklist if it's enabled in the checklist document as well
          const checklistData = checklistDoc.data();
          if (checklistData.enabled === true) {
            setChecklist(checklistData);
            setChecklistResponses(new Array(checklistData.items.length).fill(false));
          } else {
            // If the checklist is disabled in its own document, set to null
            setChecklist(null);
          }
        }
      } else {
        // Make sure checklist is null when user has disabled it
        setChecklist(null);
      }
    };
    
    fetchChecklist();
  }, [userID]);

  useEffect(() => {
    setIsFormOpen(isModalOpen);
  }, [isModalOpen, setIsFormOpen]);

  const handleAddTag = async () => {
    const trimmedTag = tagInput.trim();
    if (trimmedTag && !tags.includes(trimmedTag)) {
      const tagCollectionRef = collection(db, "Users", userID, "tags");
      const tagDocRef = doc(tagCollectionRef, trimmedTag);
      await setDoc(tagDocRef, { tag: trimmedTag });
      setTags(prevTags => [...prevTags, trimmedTag]);
      setSelectedTags(prevTags => [...prevTags, trimmedTag]);
      setTagInput(''); // This should clear the input field
    }
  };

  const handleTagChange = (event, value) => {
    setSelectedTags(value);
  };

  const handleRemoveTag = async (tag) => {
    try {
      const tagCollectionRef = collection(db, "Users", userID, "tags");
      const tagDocRef = doc(tagCollectionRef, tag);
      await deleteDoc(tagDocRef);
      setTags(prevTags => prevTags.filter(t => t !== tag));
      setSelectedTags(prevTags => prevTags.filter(t => t !== tag));
    } catch (error) {
      console.error('Error removing tag:', error);
      setModalMessage(`Failed to delete tag "${tag}". Please try again.`);
      setIsModalOpen(true);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'symbol') {
      const symbolValue = (value || '')
  .toUpperCase()
  .replace(/[^A-Z_]/g, '')   // ✅ allow underscores for futures
  .slice(0, 10);             // ✅ enough length for things like "ES_F"

      const normalizedSymbol = symbolValue === 'DAX' ? 'GER40' : symbolValue;
      setTradeData(prevData => ({ ...prevData, [name]: normalizedSymbol }));
      setShowExchangeRateInput(exchangeRateSymbols[normalizedSymbol] && getBaseCurrency(normalizedSymbol) !== 'USD' && getQuoteCurrency(normalizedSymbol) !== 'USD');
      if (normalizedSymbol.includes('USD')) setShowExchangeRateInput(false);
      return;
    }
    setTradeData(prevData => {
      let updatedData = { ...prevData, [name]: value };
      if (name === 'sizeType' && value === 'dollar') {
        updatedData = { ...updatedData, lotSizeEntry: '' };
      }
      const baseCurrency = getBaseCurrency({ symbol: updatedData.symbol });
      const quoteCurrency = getQuoteCurrency({ symbol: updatedData.symbol });
      setShowExchangeRateInput(exchangeRateSymbols[updatedData.symbol] && baseCurrency !== 'USD' && quoteCurrency !== 'USD');
      if (updatedData.symbol.includes('USD')) setShowExchangeRateInput(false);
      if (name === 'leverage') {
        const numericValue = parseFloat(value);
        updatedData = { ...updatedData, [name]: isNaN(numericValue) ? '' : numericValue };
      }
      return updatedData;
    });
  };

  const validateForm = () => {
    if (!tradeData.symbol) {
      setModalMessage('Please select a symbol.');
      setIsModalOpen(true);
      return false;
    }
  
    if (!tradeData.entry || isNaN(parseFloat(tradeData.entry))) {
      setModalMessage('Please enter a valid entry price.');
      setIsModalOpen(true);
      return false;
    }
  
    if (!tradeData.shortLong) {
      setModalMessage('Please select Short or Long.');
      setIsModalOpen(true);
      return false;
    }
  
    if (!tradeData.status) {
      setModalMessage('Please select a trade status.');
      setIsModalOpen(true);
      return false;
    }
  
    // Validate size based on sizeType
    if (!tradeData.sizeType) {
      setModalMessage('Please select a size type (Lot or Dollar).');
      setIsModalOpen(true);
      return false;
    }
const assetType = detectAssetType(tradeData.symbol);

if (assetType === 'equity') {
  // ✅ Equities — require share count
  if (!tradeData.shareCount || parseFloat(tradeData.shareCount) <= 0) {
    setModalMessage('Please enter a valid number of shares greater than 0.');
    setIsModalOpen(true);
    return false;
  }
} else if (assetType === 'futures') {
  // ✅ Futures — require contracts (lot size)
  if (!tradeData.lotSizeEntry || parseFloat(tradeData.lotSizeEntry) <= 0) {
    setModalMessage('Please enter a valid number of contracts greater than 0.');
    setIsModalOpen(true);
    return false;
  }
} else {
  // ✅ Forex / Default — require either lot size or dollar amount
  if (tradeData.sizeType === 'lot') {
    if (!tradeData.lotSizeEntry || parseFloat(tradeData.lotSizeEntry) <= 0) {
      setModalMessage('Please enter a valid lot size greater than 0.');
      setIsModalOpen(true);
      return false;
    }
  } else if (tradeData.sizeType === 'dollar') {
    if (!tradeData.sizeAmount || parseFloat(tradeData.sizeAmount) <= 0) {
      setModalMessage('Please enter a valid dollar amount greater than 0.');
      setIsModalOpen(true);
      return false;
    }
    if (!tradeData.leverage || parseFloat(tradeData.leverage) <= 0) {
      setModalMessage('Please enter a valid leverage greater than 0.');
      setIsModalOpen(true);
      return false;
    }
  }
}
  
    return true;
  };
  
  const calculateHoldTime = (entryDateTime, exitDateTime) => {
    if (!entryDateTime || !exitDateTime || entryDateTime === 'N/A' || exitDateTime === 'N/A') return 'N/A';
  
    const entry = new Date(entryDateTime);
    const exit = new Date(exitDateTime);
  
    if (isNaN(entry.getTime()) || isNaN(exit.getTime())) return 'N/A';
  
    const diffMs = exit - entry;
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const diffHours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
  
    return `${diffDays}d ${diffHours}h ${diffMinutes}m`;
  };
  
  const calculatePips = () => {
    const entryPrice = parseFloat(tradeData.entry);
    const exitPrice = parseFloat(tradeData.exit);
    if (isNaN(entryPrice) || isNaN(exitPrice) || !tradeData.symbol) return 0;
    const pipIncrement = calculatePipIncrement(tradeData.symbol);
    return Math.abs((entryPrice - exitPrice) / pipIncrement);
  };
  
  const calculateRiskRewardRatio = () => {
    const entry = parseFloat(tradeData.entry);
    const sl = parseFloat(tradeData.sl);
    const tp = parseFloat(tradeData.tp);
    if (isNaN(entry) || isNaN(sl) || isNaN(tp)) return 0;
    const risk = Math.abs(entry - sl);
    const reward = Math.abs(tp - entry);
    return risk > 0 ? (reward / risk).toFixed(2) : 0;
  };
  
  const calculateActualRRRatio = () => {
    const entry = parseFloat(tradeData.entry);
    const exit = parseFloat(tradeData.exit);
    const sl = parseFloat(tradeData.sl);
    if (isNaN(entry) || isNaN(exit) || isNaN(sl) || tradeData.status === 'Open') return 'N/A';
    const risk = Math.abs(entry - sl);
    const actualReward = Math.abs(exit - entry);
    const isLoss = tradeData.shortLong === 'Long' ? exit < entry : exit > entry;
    return risk > 0 ? (isLoss ? -1 * (actualReward / risk).toFixed(2) : (actualReward / risk).toFixed(2)) : 'N/A';
  };
const calculateRiskAmount = () => {
  const entry = parseFloat(tradeData.entry);
  const sl = parseFloat(tradeData.sl);
  if (isNaN(entry) || isNaN(sl)) return 0;

  const assetType = detectAssetType(tradeData.symbol);
  let positionSize = 0;

  // Determine position size based on asset type
  if (assetType === 'equity') {
    // Equity → number of shares
    positionSize = parseFloat(tradeData.shareCount || 0);
  } else if (assetType === 'futures') {
    // Futures → contracts (lot size × contract size)
    positionSize =
      parseFloat(tradeData.lotSizeEntry || 1) *
      getContractSize(tradeData.symbol);
  } else {
    // Forex / default → lot or dollar size
    if (tradeData.sizeType === 'lot') {
      positionSize =
        parseFloat(tradeData.lotSizeEntry || 0) *
        getContractSize(tradeData.symbol);
    } else {
      positionSize =
        parseFloat(tradeData.sizeAmount || 0) *
        parseFloat(tradeData.leverage || 1);
    }
  }

  const pipIncrement = calculatePipIncrement(tradeData.symbol);
  const pipRisk = Math.abs((entry - sl) / pipIncrement);
  return (pipRisk * positionSize * pipIncrement) / getExchangeRate(tradeData);
};

  
const calculateReturns = async () => {
  const entry = parseFloat(tradeData.entry);
  const exit = parseFloat(tradeData.exit);

  if (isNaN(entry) || (tradeData.status !== 'Open' && isNaN(exit))) {
    return { returns: 0, returnPercentage: 0 };
  }

  const assetType = detectAssetType(tradeData.symbol);
  let positionSize = 0; // ✅ Always declare first

  // ✅ Determine position size correctly for each asset type
  if (assetType === 'equity') {
    // Equities → number of shares
    positionSize = parseFloat(tradeData.shareCount || 0);
  } else if (assetType === 'futures') {
    // Futures → contracts (lot size × contract size)
    positionSize =
      parseFloat(tradeData.lotSizeEntry || 1) *
      getContractSize(tradeData.symbol);
  } else {
    // Forex / default
    if (tradeData.sizeType === 'lot') {
      positionSize =
        parseFloat(tradeData.lotSizeEntry || 0) *
        getContractSize(tradeData.symbol);
    } else {
      positionSize =
        parseFloat(tradeData.sizeAmount || 0) *
        parseFloat(tradeData.leverage || 1);
    }
  }

  if (!positionSize || isNaN(positionSize)) positionSize = 0;

  // ✅ Determine price difference (profit/loss per unit)
  const priceDiff =
    tradeData.shortLong === 'Long'
      ? exit - entry
      : entry - exit;

  // ✅ Safe exchange rate (for non-USD pairs)
  const exchangeRateValue = getExchangeRate(tradeData) || 1;

  // ✅ Gross profit/loss
  let grossReturns = (priceDiff * positionSize) / exchangeRateValue;

  // ✅ Commission handling
  let commission = 0;
  if (commissionType !== 'off') {
    switch (commissionType) {
      case 'percentage':
        commission = grossReturns * (parseFloat(commissionValue) / 100);
        break;
      case 'dollar':
        commission = parseFloat(commissionValue);
        break;
      case 'lotFixed':
        commission =
          parseFloat(commissionValue) *
          parseFloat(tradeData.lotSizeEntry || 0);
        break;
      case 'lotPercentage':
        commission =
          grossReturns *
          (parseFloat(commissionValue) / 100) *
          parseFloat(tradeData.lotSizeEntry || 0);
        break;
      default:
        commission = 0;
    }
  }

  const netReturns = grossReturns - commission;

  // ✅ Calculate % return if dollar-based sizing
  const capital =
    tradeData.sizeType === 'dollar'
      ? parseFloat(tradeData.sizeAmount) || 0
      : 0;
  const returnPercentage =
    capital > 0 ? (netReturns / capital) * 100 : 0;

  return {
    returns: isNaN(netReturns)
      ? 0
      : parseFloat(netReturns.toFixed(2)),
    returnPercentage: parseFloat(returnPercentage.toFixed(2)),
    commission,
  };
};

  
const previewUrl =
  tradeData.tradingViewUrls?.[previewTimeframe] ||
  tradeData.tradingViewUrls?.htf ||
  tradeData.tradingViewUrls?.ltf ||
  tradeData.tradingViewUrls?.extra ||
  null;

  const calculateChecklistScore = () => {
    if (!checklist || !checklistResponses) return 0;
    return checklist.items.reduce((score, item, index) => {
      return score + (checklistResponses[index] ? item.weight : 0);
    }, 0);
  };
  
const handleChecklistSubmit = async () => {
  const score = calculateChecklistScore();

  if (score < 50) {
    setIsLowScoreConfirmOpen(true);   // open confirmation modal
    return;
  }

  await handleSubmit();
  setIsChecklistModalOpen(false);
};
  
  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    if (!validateForm()) return;
  
    const { returns, returnPercentage, commission } = await calculateReturns();
    const pips = calculatePips();
    const riskRewardRatio = calculateRiskRewardRatio();
    const actualRRRatio = calculateActualRRRatio();
    const riskAmount = calculateRiskAmount();
    const holdTime = calculateHoldTime(`${tradeData.date}T${tradeData.entryTime || '00:00:00'}`, `${tradeData.exitDate}T${tradeData.exitTime || '00:00:00'}`);
    const fxbTradeScore = checklist ? `${calculateChecklistScore()}/100` : 'N/A';
    const entryDateTime = `${tradeData.date}T${tradeData.entryTime || '00:00:00'}`;
    const exitDateTime = tradeData.exitDate ? `${tradeData.exitDate}T${tradeData.exitTime || '00:00:00'}` : null;
  
    const data = {
      ...tradeData,
      returns,
      returnPercentage,
      pips,
      riskRewardRatio,
      actualRRRatio,
      riskAmount,
      holdTime,
      fxbTradeScore,
      commission,
      tags: selectedTags,
      entryDateTime,
      exitDateTime,
      userID,
    };
  
    try {
      await addDoc(collection(db, 'Users', userID, 'tradeAccounts', tradeData.tradeAccountID, 'trades'), data);
if (typeof onTradeSubmit === 'function') {
  onTradeSubmit(); // Notify parent component safely
}
      setTradeData({
        date: new Date().toISOString().split('T')[0],
        entryTime: '',
        exitDate: '',
        exitTime: '',
        symbol: '',
        entry: '',
        exit: '',
        status: 'Open',
        sizeType: 'lot',
        lotSizeEntry: '',
        shortLong: 'Long',
        returns: '',
        returnPercentage: '',
        leverage: '',
        sl: '',
        tp: '',
        riskAmount: '',
        comments: '',
        baseCurrency: '',
        exchangeRate: '',
        tradeConfidence: 'Medium',
        tags: [],
        commissionType: 'off',
        commissionValue: '',
        tradeAccountID: 'default',
  tradingViewUrls: {
    htf: '',
    ltf: '',
    extra: ``,
  },
      });
      setSelectedTags([]);
      setCommissionType('off');
      setCommissionValue('');
      setModalMessage('Trade added successfully!');
      setIsModalOpen(true);
    } catch (error) {
      console.error('Error adding trade:', error);
      setModalMessage('Failed to add trade. Please try again.');
      setIsModalOpen(true);
    }
  };
  
  const formatNumber = (n, decimals = 2) => {
  if (n === null || n === undefined || isNaN(Number(n))) return "N/A";
  const num = Number(n);
  return num % 1 === 0 ? String(num) : num.toFixed(decimals).replace(/\.?0+$/, "");
};

const getFuturesInfoLine = (symbol) => {
  const upper = (symbol || "").toUpperCase();

  // contractSizes already contains your futures multipliers (e.g. ES_F: 50, NQ_F: 20)
  const multiplier = contractSizes?.[upper];

  // your calculatePipIncrement acts like tick size for futures (e.g. ES_F: 0.25)
  const tickSize = calculatePipIncrement(upper);

  if (!multiplier || !tickSize) return null;

  const dollarsPerTick = multiplier * tickSize;

  return `Multiplier: $${formatNumber(multiplier, 2)} / point • Tick size: ${formatNumber(
    tickSize,
    5
  )} • $${formatNumber(dollarsPerTick, 2)} / tick`;
};

  return (
    <>
      <MDBox sx={{ width: '100%', px: { xs: 2, sm: 0 } }}>
        <MDButton
          variant="contained"
          color="warning"
          fullWidth
          onClick={() => setIsModalOpen(true)}
          sx={{ mb: 3 }}
        >
          Manually Input New Trade Entry
        </MDButton>

        {isModalOpen && (
          <Paper
            elevation={3}
            sx={{
              p: { xs: 2, md: 4 },
              backgroundColor: theme.palette.background.default,
              borderRadius: 2,
              width: '100%',
              maxWidth: 'none',
              boxSizing: 'border-box',
            }}
          >


            <form
              onSubmit={(e) => {
                e.preventDefault();
                if (checklist) {
                  setIsChecklistModalOpen(true);
                } else {
                  handleSubmit();
                }
              }}
              style={{ width: '100%', overflow: 'hidden' }}
            >
              <Grid container spacing={3}>
                {/* LEFT COLUMN: Inputs */}
                <Grid item xs={12} md={6}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <InputLabel htmlFor="tags" sx={{ mb: 1 }}>Tags</InputLabel>
                      <Autocomplete
                        multiple
                        freeSolo
                        options={tags}
                        value={selectedTags}
                        onChange={handleTagChange}
                        inputValue={tagInput}
                        onInputChange={(event, newInputValue) => setTagInput(newInputValue)}
                        renderTags={() => null}
                        renderOption={(props, option) => (
                          <li {...props} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span>{option}</span>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleRemoveTag(option);
                              }}
                            >
                              <DeleteIcon sx={{ color: iconColor }} fontSize="small" />
                            </IconButton>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            placeholder="Select or add tags"
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <>
                                  {tagInput && (
                                    <CloseIcon
                                      onClick={() => handleRemoveTag(tagInput)}
                                      sx={{ cursor: 'pointer' }}
                                    />
                                  )}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                          />
                        )}
                      />
                      <MDBox sx={{ mt: 1, display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {selectedTags.map((tag, index) => (
                          <Chip
                            key={index}
                            label={tag}
                            onDelete={() => setSelectedTags(prev => prev.filter(t => t !== tag))}
                            color={theme.palette.mode === 'dark' ? 'default' : 'info'}
                          />
                        ))}
                      </MDBox>
                      <MDButton
                        onClick={handleAddTag}
                        variant="contained"
                        color="warning"
                        size="small"
                        sx={{ mt: 1 }}
                      >
                        Add New Tag
                      </MDButton>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth variant="outlined" sx={{ mt: 2 }}>
                        <InputLabel id="commission-type-label">Commission Type</InputLabel>
                        <Select
                          labelId="commission-type-label"
                          value={commissionType}
                          onChange={(e) => setCommissionType(e.target.value)}
                          label="Commission Type"
                        >
                          <MenuItem value="off">Commissions Fees Off</MenuItem>
                          <MenuItem value="percentage">Profit Share Percentage</MenuItem>
                          <MenuItem value="dollar">Flat Fee In Dollars</MenuItem>
                          <MenuItem value="lotFixed">Fixed Fee Per Lot ($)</MenuItem>
                          <MenuItem value="lotPercentage">Percentage Fee Per Lot (%)</MenuItem>
                        </Select>
                      </FormControl>
                      {commissionType !== 'off' && (
                        <TextField
                          label={
                            commissionType === 'percentage'
                              ? "Enter Broker Profit Share Percentage (e.g., 10%)"
                              : commissionType === 'dollar'
                              ? "Enter Flat Fee Value ($)"
                              : commissionType === 'lotFixed'
                              ? "Enter Fixed Fee Per Lot ($)"
                              : "Enter Percentage Fee Per Lot (e.g., 0.01)"
                          }
                          value={commissionValue}
                          onChange={(e) => setCommissionValue(e.target.value)}
                          type="number"
                          fullWidth
                          sx={{ mt: 2 }}
                          inputProps={{ step: commissionType === 'lotPercentage' ? '0.01' : '0.1', min: 0 }}
                        />
                      )}
                    </Grid>

                    {/* All other input fields (unchanged logic, cleaned up styling) */}
<Grid item xs={12} sm={6}>
                      <InputLabel sx={{ textAlign: 'center', mb: 1 }}>Entry Date</InputLabel>
                      <MDInput
                        fullWidth
                        type="date"
                        name="date"
                        value={tradeData.date}
                        onChange={handleChange}
                        required
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: null,
                          sx: {
                            '& .MuiSvgIcon-root': { color: iconColor },
                            cursor: 'pointer',
                          },
                        }}
                        sx={{
                          '& .MuiInputBase-input': { cursor: 'pointer' },
                          '& .MuiOutlinedInput-root': { cursor: 'pointer' },
                        }}
                        onClick={(e) => e.target.showPicker?.()}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <InputLabel sx={{ textAlign: 'center', mb: 1 }}>Entry Time</InputLabel>
                      <MDInput
                        fullWidth
                        type="time"
                        name="entryTime"
                        value={tradeData.entryTime}
                        onChange={handleChange}
                        required
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          sx: {
                            '& .MuiSvgIcon-root': { color: iconColor },
                            cursor: 'pointer',
                          },
                        }}
                        sx={{
                          '& .MuiInputBase-input': { cursor: 'pointer' },
                          '& .MuiOutlinedInput-root': { cursor: 'pointer' },
                        }}
                        onClick={(e) => e.target.showPicker?.()}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <InputLabel sx={{ textAlign: 'center', mb: 1 }}>Exit Date</InputLabel>
                      <MDInput
                        fullWidth
                        type="date"
                        name="exitDate"
                        value={tradeData.exitDate}
                        onChange={handleChange}
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          sx: {
                            '& .MuiSvgIcon-root': { color: iconColor },
                            cursor: 'pointer',
                          },
                        }}
                        sx={{
                          '& .MuiInputBase-input': { cursor: 'pointer' },
                          '& .MuiOutlinedInput-root': { cursor: 'pointer' },
                        }}
                        onClick={(e) => e.target.showPicker?.()}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <InputLabel sx={{ textAlign: 'center', mb: 1 }}>Exit Time</InputLabel>
                      <MDInput
                        fullWidth
                        type="time"
                        name="exitTime"
                        value={tradeData.exitTime}
                        onChange={handleChange}
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          sx: {
                            '& .MuiSvgIcon-root': { color: iconColor },
                            cursor: 'pointer',
                          },
                        }}
                        sx={{
                          '& .MuiInputBase-input': { cursor: 'pointer' },
                          '& .MuiOutlinedInput-root': { cursor: 'pointer' },
                        }}
                        onClick={(e) => e.target.showPicker?.()}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <InputLabel sx={{ mb: 1 }}>Symbol</InputLabel>
                      <Autocomplete
                        options={symbolOptions}
                        getOptionLabel={(option) => (option === 'DAX' ? 'DAX (GER40)' : option)}
                        value={tradeData.symbol || ''}
                        onChange={(event, newValue) => handleChange({ target: { name: 'symbol', value: newValue || '' } })}
                        renderInput={(params) => (
                          <MDInput
                            {...params}
                            fullWidth
                            label="e.g. TSLA or GBPUSD"
                            variant="outlined"
                            inputProps={{ ...params.inputProps, maxLength: 10 }}
                          />
                        )}
                        isOptionEqualToValue={(option, value) => option === value || (option === 'GER40' && value === 'DAX') || (option === 'DAX' && value === 'GER40')}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth sx={{ mt: 2 }}>
                        <InputLabel>Short/Long</InputLabel>
                        <Select value={tradeData.shortLong} onChange={handleChange} name="shortLong" label="Short/Long">
                          <MenuItem value="Long">Long</MenuItem>
                          <MenuItem value="Short">Short</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>

{(() => {
  const assetType = detectAssetType(tradeData.symbol);

  // --- EQUITIES ---
if (assetType === "futures") {
  const infoLine = getFuturesInfoLine(tradeData.symbol);

  return (
    <Grid item xs={12} sm={6}>
      <InputLabel sx={{ mb: 1 }}>Contracts</InputLabel>

      <MDInput
        fullWidth
        label="Enter the number of contracts"
        name="lotSizeEntry"
        type="number"
        value={tradeData.lotSizeEntry || ""}
        onChange={handleChange}
      />

      {infoLine && (
        <MDTypography
          variant="caption"
          sx={{ display: "block", mt: 0.75, opacity: 0.75 }}
        >
          {infoLine}
        </MDTypography>
      )}
    </Grid>
  );
}

  // --- FUTURES ---
  if (assetType === 'futures') {
    return (
      <Grid item xs={12} sm={6}>
        <InputLabel sx={{ mb: 1 }}>Lot Size (Contracts)</InputLabel>
        <MDInput
          fullWidth
          label="Enter the number of contracts"
          name="lotSizeEntry"
          type="number"
          value={tradeData.lotSizeEntry || ''}
          onChange={handleChange}
        />
      </Grid>
    );
  }

  // --- FOREX / DEFAULT ---
  return (
    <>
      <Grid item xs={12} sm={6}>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>Size Position Type</InputLabel>
          <Select
            value={tradeData.sizeType}
            onChange={handleChange}
            name="sizeType"
            label="Size Position Type"
          >
            <MenuItem value="lot">Lot Size</MenuItem>
            <MenuItem value="dollar">Dollar Amount</MenuItem>
          </Select>
        </FormControl>
      </Grid>

      {tradeData.sizeType === 'lot' && (
        <Grid item xs={12} sm={6}>
          <InputLabel sx={{ mb: 1 }}>Lot Size</InputLabel>
          <MDInput
            fullWidth
            label="Enter the lot size"
            name="lotSizeEntry"
            value={tradeData.lotSizeEntry}
            onChange={handleChange}
            type="number"
          />
        </Grid>
      )}

      {tradeData.sizeType === 'dollar' && (
        <>
          <Grid item xs={12} sm={6}>
            <InputLabel sx={{ mb: 1 }}>$ Dollar Amount</InputLabel>
            <MDInput
              fullWidth
              label="Enter the Dollar amount"
              name="sizeAmount"
              value={tradeData.sizeAmount}
              onChange={handleChange}
              type="number"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputLabel sx={{ mb: 1 }}>Leverage</InputLabel>
            <MDInput
              fullWidth
              label="Amount of leverage used"
              name="leverage"
              value={tradeData.leverage}
              onChange={handleChange}
              type="number"
            />
          </Grid>
        </>
      )}
    </>
  );
})()}

                    <Grid item xs={12} sm={6}>
                      <InputLabel sx={{ mb: 1 }}>Entry</InputLabel>
                      <MDInput fullWidth label="Enter the entry price" name="entry" value={tradeData.entry} onChange={handleChange} type="number" />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <InputLabel sx={{ mb: 1 }}>Exit</InputLabel>
                      <MDInput fullWidth label="Enter the exit price" name="exit" value={tradeData.exit} onChange={handleChange} type="number" />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <InputLabel sx={{ mb: 1 }}>Stop Loss</InputLabel>
                      <MDInput fullWidth label="Enter your stop loss limit" name="sl" value={tradeData.sl} onChange={handleChange} type="number" />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <InputLabel sx={{ mb: 1 }}>Take Profit</InputLabel>
                      <MDInput fullWidth label="Enter your take profit limit" name="tp" value={tradeData.tp} onChange={handleChange} type="number" />
                    </Grid>

                    {showExchangeRateInput && (
                      <Grid item xs={12} sm={6}>
                        <InputLabel sx={{ mb: 1 }}>Exchange Rate</InputLabel>
                        <MDInput
                          fullWidth
                          label={`Leave blank to auto-fetch ${exchangeRateSymbols[tradeData.symbol]}, or enter manually`}
                          name="exchangeRate"
                          value={tradeData.exchangeRate}
                          onChange={handleChange}
                        />
                      </Grid>
                    )}

                    <Grid item xs={12} sm={6}>
                      <InputLabel sx={{ mb: 1 }}>Comments</InputLabel>
                      <MDTypography
  component="div"
  sx={{
    width: "100%",
    border: `1px solid ${iconColor}`,
    borderRadius: "8px",
    padding: "3px",
    backgroundColor: theme.palette.background.default,
  }}
>
  <TextareaAutosize
    minRows={1}
    placeholder="   Enter any comments"
    name="comments"
    value={tradeData.comments}
    onChange={handleChange}
    style={{
      width: "100%",
      background: "transparent",
      border: "none",
      outline: "none",
      resize: "none",
      color: "inherit",
      fontFamily: "inherit",
      fontSize: "14px",
      lineHeight: 1.5,
    }}
  />
</MDTypography>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth sx={{ mt: 2 }}>
                        <InputLabel>Status</InputLabel>
                        <Select value={tradeData.status} onChange={handleChange} name="status" label="Status">
                          <MenuItem value="Open">Open</MenuItem>
                          <MenuItem value="Closed">Closed</MenuItem>
                          <MenuItem value="Missed">Missed</MenuItem>
                          <MenuItem value="Cancelled">Cancelled</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth sx={{ mt: 2 }}>
                        <InputLabel>Trade Confidence</InputLabel>
                        <Select value={tradeData.tradeConfidence} onChange={handleChange} name="tradeConfidence" label="Trade Confidence">
                          <MenuItem value="High" sx={{ display: 'flex', alignItems: 'center' }}>
                            <SentimentVerySatisfiedIcon sx={{ color: 'green', mr: 1 }} /> High
                          </MenuItem>
                          <MenuItem value="Medium" sx={{ display: 'flex', alignItems: 'center' }}>
                            <SentimentSatisfiedIcon sx={{ color: 'orange', mr: 1 }} /> Medium
                          </MenuItem>
                          <MenuItem value="Low" sx={{ display: 'flex', alignItems: 'center' }}>
                            <SentimentDissatisfiedIcon sx={{ color: 'red', mr: 1 }} /> Low
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth sx={{ mt: 2 }}>
                        <InputLabel>Trade Account</InputLabel>
                        <Select value={tradeData.tradeAccountID} onChange={handleChange} name="tradeAccountID" label="Trade Account">
                          {tradeAccounts.map((account) => (
                            <MenuItem key={account.id} value={account.id}>
                              {account.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <InputLabel sx={{ mb: 1 }}>TradingView Chart URL</InputLabel>
<MDInput
  fullWidth
  label="TradingView HTF (e.g. 4H)"
  placeholder="https://www.tradingview.com/x/XXXXXX/"
  value={tradeData.tradingViewUrls?.htf || ''}
  onChange={(e) =>
    setTradeData(prev => ({
      ...prev,
      tradingViewUrls: {
        ...prev.tradingViewUrls,
        htf: e.target.value
      }
    }))
  }
/>

<MDInput
  sx={{ mt: 2 }}   // ✅ THIS
  fullWidth
  label="TradingView LTF (e.g. 15m)"
  placeholder="https://www.tradingview.com/x/XXXXXX/"
  value={tradeData.tradingViewUrls?.ltf || ''}
  onChange={(e) =>
    setTradeData(prev => ({
      ...prev,
      tradingViewUrls: {
        ...prev.tradingViewUrls,
        ltf: e.target.value
      }
    }))
  }
/>
<MDInput
  sx={{ mt: 2 }}   // ✅ THIS
  fullWidth
  label="TradingView Link (Extra / Focus)"
  value={tradeData.tradingViewUrls?.extra || ""}
  onChange={(e) =>
    setTradeData((prev) => ({
      ...prev,
      tradingViewUrls: {
        ...prev.tradingViewUrls,
        extra: e.target.value,
      },
    }))
  }
/>
                    </Grid>
                  </Grid>
                </Grid>

                {/* RIGHT COLUMN: Chart Preview */}
                <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: { md: '100%' },
                  }}
                >
                  <MDTypography variant="h6" sx={{ mb: 2 }}>
                    Chart Preview
                  </MDTypography>
                  <MDBox sx={{ display: 'flex', gap: 1, mb: 2 }}>
  <MDButton
    size="small"
    variant={previewTimeframe === 'htf' ? 'contained' : 'outlined'}
    onClick={() => setPreviewTimeframe('htf')}
  >
    HTF
  </MDButton>
  <MDButton
    size="small"
    variant={previewTimeframe === 'ltf' ? 'contained' : 'outlined'}
    onClick={() => setPreviewTimeframe('ltf')}
  >
    LTF
  </MDButton>
  <MDButton
    size="small"
    variant={previewTimeframe === 'extra' ? 'contained' : 'outlined'}
    onClick={() => setPreviewTimeframe('extra')}
  >
    Extra/Focus
  </MDButton>
</MDBox>
                  <MDBox
                    sx={{
                      flexGrow: 1,
                      bgcolor: 'grey.100',
                      borderRadius: 2,
                      overflow: 'hidden',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      p: 2,
                      minHeight: 400,
                    }}
                  >
{previewUrl ? (
  <img
    src={previewUrl}
    alt="TradingView Chart Preview"
    onError={(e) => {
      e.target.src = '';
      e.target.alt = 'Invalid URL or failed to load';
    }}
    style={{
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      borderRadius: '8px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    }}
  />
) : (
  <MDTypography variant="body2" color="text.secondary" align="center">
    Enter a TradingView HTF, LTF, or Focus link above to preview it here.
You can attach up to three charts per trade — one for bias (HTF), one for entry (LTF), and one for your execution or exit model (Focus).
  </MDTypography>
)}
                  </MDBox>
                </Grid>
              </Grid>

              <MDBox sx={{ display: 'flex', justifyContent: 'space-between', mt: 4, gap: 2 }}>
                <MDButton variant="outlined" color="error" onClick={() => setIsModalOpen(false)} size="large">
                  Cancel
                </MDButton>
                <MDButton type="submit" variant="contained" color="success" size="large">
                  Submit Trade
                </MDButton>
              </MDBox>
            </form>

            {modalMessage && (
              <MDTypography color="error" sx={{ mt: 3, textAlign: 'center' }}>
                {modalMessage}
              </MDTypography>
            )}
          </Paper>
        )}
      </MDBox>

      {/* Checklist Modal */}
      <Modal
        isOpen={isChecklistModalOpen && !!checklist}
        onClose={() => setIsChecklistModalOpen(false)}
        title={`Trade Checklist: ${checklist?.name || ''}`}
      >
        <MDBox mt={2}>
          {checklist?.items.map((item, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  checked={checklistResponses[index] || false}
                  onChange={(e) => {
                    const newResponses = [...checklistResponses];
                    newResponses[index] = e.target.checked;
                    setChecklistResponses(newResponses);
                  }}
                />
              }
              label={`${item.description} (${item.weight}%)`}
            />
          ))}
        </MDBox>
        <MDTypography
          variant="body2"
          mt={2}
          color={calculateChecklistScore() > 79 ? 'success' : calculateChecklistScore() >= 49 ? 'warning' : 'error'}
          sx={{ fontWeight: 'bold' }}
        >
          Current FXB Trade Score: {calculateChecklistScore()}/100
        </MDTypography>
        <MDBox sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
          <MDButton variant="contained" color="success" onClick={handleChecklistSubmit}>
            Submit Trade
          </MDButton>
          <MDButton variant="outlined" color="error" onClick={() => setIsChecklistModalOpen(false)}>
            Cancel
          </MDButton>
        </MDBox>
      </Modal>
      <Modal
  isOpen={isLowScoreConfirmOpen}
  onClose={() => setIsLowScoreConfirmOpen(false)}
  title="Low Trade Score"
>
  <MDTypography>
    Your trade score is below 50. Are you sure you want to proceed?
  </MDTypography>

  <MDBox sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
    <MDButton
      variant="outlined"
      color="error"
      onClick={() => setIsLowScoreConfirmOpen(false)}
    >
      Cancel
    </MDButton>

    <MDButton
      variant="contained"
      color="success"
      onClick={async () => {
        setIsLowScoreConfirmOpen(false);
        setIsChecklistModalOpen(false);
        await handleSubmit();        // ✅ force submit
      }}
    >
      Yes, Submit Anyway
    </MDButton>
  </MDBox>
</Modal>
    </>
  );
};

TradeEntryForm.propTypes = {
  userID: PropTypes.string.isRequired,
  onTradeSubmit: PropTypes.func.isRequired,
  setIsFormOpen: PropTypes.func.isRequired
};

export { fetchExchangeRate };
export default TradeEntryForm;